import { ReactComponent as GrasaVisceralImage } from "../../assets/metricas/Grasa_visceral_image.svg";
import { ReactComponent as AguaCorporalImage } from "../../assets/metricas/agua_corporal_image.svg";
import { ReactComponent as BmrImage } from "../../assets/metricas/bmr_image.svg";
import { ReactComponent as EdadCorporalImage } from "../../assets/metricas/edad_corporal_image.svg";
import { ReactComponent as GrasaCorporalImage } from "../../assets/metricas/grasa_corporal_image.svg";
import { ReactComponent as GrasaSubcutaneaImage } from "../../assets/metricas/grasa_subcutanea_image.svg";
import { ReactComponent as ImcImage } from "../../assets/metricas/imc_image.svg";
import { ReactComponent as MasaEsqueleticaImage } from "../../assets/metricas/masa_esqueletica_image.svg";
import { ReactComponent as MasaMuscularImage } from "../../assets/metricas/masa_muscular_image.svg";
import { ReactComponent as MusculoEsqueleticoImage } from "../../assets/metricas/musculo_esqueletico_image.svg";
import { ReactComponent as PesoImage } from "../../assets/metricas/peso_image.svg";
import { ReactComponent as ProteinaImage } from "../../assets/metricas/proteina_image.svg";

export const athleteObjectives = [
  {
    name: "Número de días de entrenamiento a la semana",
    value: null,
    label: "training_days_per_week_goal",
    label_actual: "training_days_per_week_actual",
  },
  {
    name: "Medición diaria de tensión arterial",
    value: null,
    label: "daily_blood_pressure_check_goal",
    label_actual: "daily_blood_pressure_check_actual",
  },
  {
    name: "Caminata semanal (Km)",
    value: null,
    label: "weekly_walk_km_goal",
    label_actual: "weekly_walk_km_actual",
  },
];
export const athleteObjectivesControl = [
  {
    name: "Número de días de entrenamiento hasta prox. control",
    value: null,
    label: "training_days",
  },
  {
    name: "Medición diaria de tensión arterial",
    value: null,
    label: "daily_blood_pressure",
  },
  {
    name: "Distancia hasta prox. control (Km)",
    value: null,
    label: "training_distance_km",
  },
];
export const reposoBase = [
  {
    name: "FC. PROM",
    label: "resting_hr_avg_goal",
  },
  {
    name: "FC. MAX",
    label: "resting_hr_max_goal",
  },
  {
    name: "VFC",
    label: "resting_hrv_goal",
  },
];

export const reposoBaseControl = [
  {
    name: "FC. PROM",
    label: "fc_prom",
  },
  {
    name: "FC. MAX",
    label: "fc_max",
  },
  {
    name: "VFC",
    label: "vfc",
  },
];

export const recuperationBase = [
  {
    name: "FC. MAX",
    label: "recovery_hr_max_goal",
  },
  {
    name: "FC. en 5 minutos",
    label: "recovery_hr_5min_goal",
  },
  {
    name: "FC. en 7 minutos",
    label: "recovery_hr_7min_goal",
  },
  {
    name: "FC. en 10 minutos",
    label: "recovery_hr_10min_goal",
  },
];
export const recuperationBaseControl = [
  {
    name: "FC. MAX",
    label: "fc_max",
  },
  {
    name: "FC. en 5 minutos",
    label: "fc_5_min",
  },
  {
    name: "FC. en 7 minutos",
    label: "fc_7_min",
  },
  {
    name: "FC. en 10 minutos",
    label: "fc_10_min",
  },
];
export const saturationBase = [
  {
    name: "SAT",
    label: "oxygen_saturation_goal",
  },
];
export const saturationBaseControl = [
  {
    name: "SAT",
    label: "values",
  },
];

export const optionLogsBase = [
  {
    id: 1,
    name: "Peso",
    label: "weight_goal",
    image: <PesoImage width="100%" />,
    label_actual: "weight_actual",
    logKey: "HEALTH_LOG_WEIGHT",
    scaleId: 1,
  },
  {
    id: 2,
    name: "IMC",
    label: "imc_goal",
    image: <ImcImage width="100%" />,
    label_actual: "imc_actual",
    logKey: "HEALTH_LOG_IMC",
    scaleId: 2,
  },
  {
    id: 3,
    name: "Grasa corporal",
    label: "body_fat_goal",
    image: <GrasaCorporalImage width="100%" />,
    label_actual: "body_fat_actual",
    logKey: "HEALTH_LOG_BODY_FAT",
    scaleId: 3,
  },
  {
    id: 5,
    name: "Grasa subcutánea",
    label: "subcutaneous_fat_goal",
    image: <GrasaSubcutaneaImage width="100%" />,
    label_actual: "subcutaneous_fat_actual",
    logKey: "HEALTH_LOG_UNDERSKIN_FAT",
    scaleId: 5,
  },
  {
    id: 6,
    name: "Grasa visceral",
    label: "visceral_fat_goal",
    image: <GrasaVisceralImage width="100%" />,
    label_actual: "visceral_fat_actual",
    logKey: "HEALTH_LOG_VISCERAL_FAT",
    scaleId: 6,
  },
  {
    id: 7,
    name: "Agua corporal",
    label: "body_water_goal",
    image: <AguaCorporalImage width="100%" />,
    label_actual: "body_water_actual",
    logKey: "HEALTH_LOG_CORPORAL_WATER",
    scaleId: 7,
  },
  {
    id: 8,
    name: "Músculo esquelético",
    label: "bone_muscle_goal",
    image: <MusculoEsqueleticoImage width="100%" />,
    label_actual: "bone_muscle_actual",
    logKey: "HEALTH_LOG_BONE_MUSCLE",
    scaleId: 8,
  },
  {
    id: 10,
    name: "Masa muscular",
    label: "muscle_mass_goal",
    image: <MasaMuscularImage width="100%" />,
    label_actual: "muscle_mass_actual",
    logKey: "HEALTH_LOG_MUSCLE_MASS",
    scaleId: 10,
  },
  {
    id: 9,
    name: "Masa esquelética",
    label: "bone_mass_goal",
    image: <MasaEsqueleticaImage width="100%" />,
    label_actual: "bone_mass_actual",
    logKey: "HEALTH_LOG_BONE_MASS",
    scaleId: 9,
  },
  {
    id: 11,
    name: "Proteína",
    label: "protein_goal",
    image: <ProteinaImage width="100%" />,
    label_actual: "protein_actual",
    logKey: "HEALTH_LOG_PROTEIN",
    scaleId: 11,
  },
  {
    id: 12,
    name: "BMR",
    label: "bmr_goal",
    image: <BmrImage width="100%" />,
    label_actual: "bmr_actual",
    logKey: "HEALTH_LOG_BMR",
    scaleId: 12,
  },
  {
    id: 13,
    name: "Edad Corporal",
    label: "body_age_goal",
    image: <EdadCorporalImage width="100%" />,
    label_actual: "body_age_actual",
    logKey: "HEALTH_LOG_HEALTH_AGE",
    scaleId: 13,
  },
];

export const testPhysicalBase = [
  {
    id: 1,
    name: "Máximos pushups en 1 minuto",
    label: "max_pushups_1min_goal",
    label_actual: "max_pushups_1min_actual",
    logKey: "max_pushups",
    controlKey: "max_pushups_1min_goal",
  },
  {
    id: 2,
    name: "Máximas burpees en 1 minuto",
    label: "max_burpees_1min_goal",
    label_actual: "max_burpees_1min_actual",
    logKey: "max_burpees",
    controlKey: "max_burpees_1min_goal",
  },
  {
    id: 3,
    name: "Máximos squad isómetricos en 1 minuto",
    label: "max_isometric_squat_1min_goal",
    label_actual: "max_isometric_squat_1min_actual",
    logKey: "max_isometric_squat",
    controlKey: "max_isometric_squat_1min_goal",
  },
  {
    id: 4,
    name: "Máximas planchas de antebrazo en 1 minuto",
    label: "max_plank_forearm_1min_goal",
    label_actual: "max_plank_forearm_1min_actual",
    logKey: "max_plank_forearm",
    controlKey: "max_plank_forearm_1min_goal",
  },
  {
    id: 5,
    name: "Máximo tiempo de plancha (palmas)",
    label: "max_plank_palms_1min_goal",
    label_actual: "max_plank_palms_1min_actual",
    logKey: "max_plank_palms",
    controlKey: "max_plank_palms_1min_goal",
  },
  {
    id: 6,
    name: "Maximas abdomninales en 1 minuto",
    label: "max_situps_1min_goal",
    label_actual: "max_situps_1min_actual",
    logKey: "max_situps",
    controlKey: "max_situps_1min_goal",
  },
  {
    id: 7,
    name: "Máximas sentadillas en 1 minuto",
    label: "max_squat_1min_goal",
    label_actual: "max_squat_1min_actual",
    logKey: "max_squat",
    controlKey: "max_squat_1min_goal",
  },
  {
    id: 8,
    name: "Máximas extensiones de tronco en 1 minuto",
    label: "max_trunk_extension_1min_goal",
    label_actual: "max_trunk_extension_1min_actual",
    logKey: "max_trunk_extension",
    controlKey: "max_trunk_extension_1min_goal",
  },
];
